<template>
  <div class="status-charging-use">

    <!-- START Search Box -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-xl-3">
                <b-form-group label-class="col-form-label"
                              label="충전소" label-for="searchStation"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchStation"
                               v-model="searchForm.station" :options="stationOptions"
                               label="placeName" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               :max-height="202" @input="search">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>
<!--              <search-buttons layout-class="col-lg-9 ct-margin-top-25"-->
<!--                              resetBtnClass="search-btn-reset" searchBtnClass="search-btn-search"-->
<!--                              :reset-fn="reset" :search-fn="search" />-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Search Box -->

    <!-- START Charger Status -->
    <div class="row">
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-xl-4">
                <card-title icon-image="mdi-ev-station" title="실시간 충전기 상태" text-color="title"/>
              </div>

              <div class="col-lg-8 offset-lg-4 pt-3 pe-3">
                <div class="text-end align-items-end">
                  <span class="text-secondary">전체 | </span>
                  <span class="fw-bold">{{ status.total }}</span>
                  <span class="text-secondary ms-1">건</span>
                </div>
              </div>

            </div>
            <div class="charger-status-table mt-3">
              <b-table class="datatables text-nowrap"
                       :fields="fields" :items="statusItems">
                <template #cell(capacity)="data">
                  {{ data.item.capacity }} kW
                </template>
                <template #cell(errorCode)="data">
                  {{ data.item.errorCode === 'NoError' ? '-' : $_app.code.errorCode[data.item.errorCode] }}
                </template>
                <template #cell(vendorErrorCode)="data">
                  {{ $_app.code.vendorErrorCode[data.item.vendorErrorCode] || '-' }}
                </template>
                <template #cell(diffHour)="data">
                  {{ getStatusTime(data) }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="card card-height-100 shadow">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <card-title icon-image="mdi-alarm-light" title="충전기 고장감지" text-color="title"/>
              </div>
              <div v-if="searchForm.station" class="col-3 text-align-end">
                <b-button class="ct-small-btn" size="sm" variant="outline-success"
                          @click="$refs.failureModal.show=true">
                  상세
                </b-button>
              </div>
            </div>
            <div class="mt-2" v-if="!$_utils.isEmpty(searchForm.station)">
              <template v-for="(item, i) in failureItems">
                <div class="row mb-3" v-if="i % 2 === 0">
                  <div class="col-6">
                    <div class="charger-failure-info" :class="`${failureItems[i].failureCnt > 0 ? 'active' : ''}`">
                      <span class="charger-failure-info-bg">{{ $_app.code.errorCode[failureItems[i].errorCode] }}</span>
                      <span class="charger-failure-info-text">{{ failureItems[i].failureCnt }}</span>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="charger-failure-info" :class="`${failureItems[i+1].failureCnt > 0 ? 'active' : ''}`">
                      <span class="charger-failure-info-bg">
                        {{ $_app.code.errorCode[failureItems[i + 1].errorCode] }}
                      </span>
                      <span class="charger-failure-info-text">{{ failureItems[i + 1].failureCnt }}</span>
                    </div>
                  </div>
                </div>
              </template>
              <hr/>
              <div class="row">
                <div class="col-6">
                  <div class="charger-failure-info" :class="`${failureStatus.noneUse > 0 ? 'active' : ''}`">
                    <span class="charger-failure-info-bg">장기 미사용</span>
                    <span class="charger-failure-info-text">{{ failureStatus.noneUse }}</span>
                  </div>
                </div>
                <div class="col-6">
                  <div class="charger-failure-info" :class="`${failureStatus.low > 0 ? 'active' : ''}`">
                    <span class="charger-failure-info-bg">출력 저하</span>
                    <span class="charger-failure-info-text">{{ failureStatus.low }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- END Charger Status -->

    <!-- START Evse Chart -->
    <div class="row">
      <div class="col-lg-12">
        <div class="card shadow mb-0">
          <div class="card-body">
            <div class="row">

              <div class="col-xl-2">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="충전기" label-for="searchEvse"
                              label-cols-xl="4" lcontent-cols-xl="8"
                              label-cols="3" content-cols="9">
                  <multiselect id="searchEvse"
                               v-model="searchForm.evse" :options="evseOptions"
                               label="csoEvseNum" placeholder="" select-label=""
                               :allow-empty="false" deselect-label=""
                               :max-height="202" @input="searchEvse">
                    <span slot="noResult">No Result</span>
                  </multiselect>
                </b-form-group>
              </div>

              <div class="col-xl-3 offset-xl-1 mt-2 mt-xl-0">
                <b-form-group class="ct-mb-margin-bottom-100" label-class="col-form-label"
                              label="조회일" label-for="searchDate"
                              label-cols="3" content-cols="9">
                  <div class="row">
                    <div class="col-2 col-sm-1 col-xl-2">
                      <b-button size="sm" variant="outline-secondary" class="h-100" @click="beforeDate()">◀</b-button>
                    </div>
                    <div class="col">
                      <date-picker id="searchDate" v-model="searchForm.selectedDate"
                                   value-type="format" format="YYYY-MM-DD" lang="ko"
                                   :disabled-date="disabledAfterDay" @input="searchEvse">
                        <template v-slot:footer="{ emit }">
                          <div style="text-align: left">
                            <b-button size="sm" variant="outline-primary" @click="emit(new Date())">
                              오늘
                            </b-button>
                          </div>
                        </template>
                      </date-picker>
                    </div>
                    <div class="col-2 col-sm-1 col-xl-2 text-end">
                      <b-button size="sm" variant="outline-secondary" class="h-100" @click="nextDate()"
                                :disabled="today <= searchForm.selectedDate">▶
                      </b-button>
                    </div>
                  </div>
                </b-form-group>
              </div>

              <div v-if="searchForm.station" class="col-xl-6 text-end mt-2 mt-xl-0">
                <b-button variant="outline-success"
                          @click="$refs.recentUsageStatus.show=true">
                  충전기별 이용 비교
                </b-button>
              </div>

            </div>
            <hr/>

            <!-- START Top Chart Area -->
            <div class="row">
              <div class="col-xl-6">
                <div class="card">
                  <div class="card-body">
                    <card-title icon-image="mdi-clipboard-text-multiple-outline" title="충전 이용자 현황" text-color="title"/>
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="card" v-for="(item, i) in userStatusList"
                             :class="`bg-${item.color}-gradient ${i>1 ? 'mb-0' : 'mb-3'}`">
                          <div class="card-body pt-3 pb-1">
                            <div class="float-end">
                              <div class="text-muted avatar-sm mx-auto">
                                <span class="avatar-title rounded-circle bg-light font-size-24">
                                  <i class="mdi" :class="`mdi-${item.icon} text-${item.color}`"/>
                                </span>
                              </div>
                            </div>
                            <div>
                              <div class="text-uppercase fw-semibold mb-1">{{ item.name }}</div>
                              <h4>
                                <span class="main-value">
                                  <countTo :startVal="0" :endVal="userStatus.count[item.type1]" :duration="1000"/>
                                </span>
                                <span class="sub-value font-size-12">명</span>
                                <span class="main-value ps-4">
                                  <countTo :startVal="0" :endVal="userStatus.count[item.type2]" :duration="1000"/>
                                </span>
                                <span class="sub-value font-size-12">회</span>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-lg-8">
                        <div class="card">
                          <div class="card-body pb-1">
                            <div class="row">
                              <div class="col-lg-4">
                                <h6 class="text-muted">충전량 (kWh)</h6>
                                <h4 class="text-align-end me-3 mt-3">
                                  {{(userStatus.totEnergy).toLocaleString('ko-KR') }}
                                </h4>
                                <div class="text-align-end me-3 font-size-12 ct-mb-margin-bottom-100"
                                     :class="setCompare('text', userStatus.energyRate)">
                                  <i class="bx icon-padding-right" :class="setCompare('icon', userStatus.energyRate)"/>
                                  <span class="pb-2">{{ userStatus.energyRate.toFixed(0) }} %</span>
                                </div>
                              </div>
                              <div class="col-lg-8">
                                <apexchart ref="userStatusPowerChart" height="100"
                                           :options="userStatusPowerChartOptions"
                                           :series="userStatusPowerChartOptions.series" />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="card mb-0">
                          <div class="card-body pb-1">
                            <div class="row">
                              <div class="col-lg-4">
                                <h6 class="text-muted">충전금액 (원)</h6>
                                <h4 class="text-align-end me-3 mt-3">
                                  {{(userStatus.totCost).toLocaleString('ko-KR') }}
                                </h4>
                                <div class="text-align-end me-3 font-size-12 ct-mb-margin-bottom-100"
                                     :class="setCompare('text', userStatus.costRate)">
                                  <i class="bx icon-padding-right" :class="setCompare('icon', userStatus.costRate)"/>
                                  <span class="pb-2">{{ userStatus.costRate.toFixed(0) }} %</span>
                                </div>
                              </div>
                              <div class="col-lg-8">
                                <apexchart ref="userStatusPriceChart" height="100"
                                           :options="userStatusPriceChartOptions"
                                           :series="userStatusPriceChartOptions.series" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <card-title class=col icon-image="mdi mdi-ev-station" title="충전 트랜잭션별 측정 값" text-color="title"/>
                      <div v-if="ChargeAmountChartItems" class="col-4 text-end">
                        <b-button-group v-for="(trns, i) of ChargeAmountChartItems" size="sm" :key="`transaction${i}`">
                          <b-button pill variant="outline-dark" class="me-2"
                                    :title="`ID: ${Object.keys(trns)[0]}`" :pressed.sync="trnsBtnState[i]"
                                    @click="changeTransactionId(i)">
                            {{ i + 1 }}
                          </b-button>
                        </b-button-group>
                      </div>
                    </div>
                    <apexchart ref="placeStockChart" type="line" height="272" :options="placeStockChartOptions"
                               :series="placeStockChartOptions.series" />
                  </div>
                </div>
              </div>
            </div>
            <!-- END Top Chart Area -->

            <!-- START Bottom Chart Area -->
            <div class="row">
              <div class="col-xl-6">
                <div class="card mb-0 card-height-100">
                  <div class="card-body">
                    <card-title icon-image="mdi-calendar-week" title="최근 1주일 이용 현황" text-color="title"/>
                    <div>
                      <apexchart ref="weekUseStatusChart" height="260" :options="weekUseStatusChartOptions"
                                 :series="weekUseStatusChartOptions.series" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-xl-6">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title mb-3">
                      <span class="icon-padding-right-50">
                        <i class="mdi mdi-calendar-clock ct-card-title"/>
                      </span>
                      <span class="ct-card-title">시간별 평균 이용률</span>
                      <span class="font-size-18 ms-2" id="util-desc">
                          <i class="mdi mdi-comment-question ct-text-main"/>
                      </span>

                      <b-tooltip target="util-desc" placement="right" custom-class="desc-tooltip">
                        <pre class="pre-tag-tooltip">{{ utilDescription }}</pre>
                      </b-tooltip>
                    </h4>

                    <div>
                      <apexchart ref="utilChart" type="bar" height="260" :options="utilChartOptions"
                                 :series="utilChartOptions.series" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- END Bottom Chart Area -->
          </div>
        </div>
      </div>
    </div>
    <!-- END Evse Chart -->

    <FailureModal ref="failureModal" v-if="!$_utils.isEmpty(searchForm.station)"
                  :place-id="searchForm.station.placeId"
                  :today="today"
                  :evse-options="evseOptions"
                  :failure-list="failureItems"/>

    <RecentUsageStatus ref="recentUsageStatus" v-if="!$_utils.isEmpty(searchForm.station)"
                       :place-id="searchForm.station.placeId"/>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import countTo from 'vue-count-to';
import cardTitle from '@/views/components/cardTitle.vue';
import FailureModal from '@/views/pages/status/FailureModal.vue';
import RecentUsageStatus from '@/views/pages/status/RecentUsageStatusModal';
import SearchButtons from "@/views/components/searchButtons.vue";

export default {
  components: { SearchButtons, Multiselect, cardTitle, FailureModal, countTo, RecentUsageStatus },
  data() {
    const _sApi = this.$_app.service.station;
    const _eApi = this.$_app.service.evseUse;
    return {
      stationApi: _sApi,
      evseApi: _eApi,
      today: this.$moment().format('YYYY-MM-DD'),
      searchForm: {
        station: null,
        evse: null,
        /*selectedDate: this.$moment(new Date()).subtract(1,'day').format('YYYY-MM-DD')*/
        selectedDate: this.$moment().format('YYYY-MM-DD')

      },
      stationOptions: [],
      status: { total: 0, available: 0, occupied: 0, reserved: 0, faulted: 0 },
      fields: [
        _eApi.schema.csoEvseNum,
        _eApi.schema.capacity,
        _eApi.schema.connectorStatus,
        _eApi.schema.errorCode,
        // _eApi.schema.vendorErrorCode,
        _eApi.schema.diffHour,
        _eApi.schema.notiTime
      ],
      statusItems: null,
      evseOptions: [],
      failureStatus: { noneUse: 0, low: 0 },
      failureItems: null,
      userStatus: {
        count: {
          memCnt: 0,
          memUsedCnt: 0,
          nonmemCnt: 0,
          nonmemUsedCnt: 0,
          roamingCnt: 0,
          roamingUsedCnt: 0
        },
        memberCost: 0,
        memberEnergy: 0,
        nonmemberCost: 0,
        nonmemberEnergy: 0,
        roamingCost: 0,
        roamingEnergy: 0,
        totCost: 0,
        totEnergy: 0,
        energyRate: 0,
        costRate: 0,
        weekChart: [],
      },
      userStatusList: [
        { type1: 'memCnt', type2: 'memUsedCnt', name: '회원', color: 'success', icon: 'account' },
        { type1: 'roamingCnt', type2: 'roamingUsedCnt', name: '로밍', color: 'warning', icon: 'account-alert' },
        { type1: 'nonmemCnt', type2: 'nonmemUsedCnt', name: '비회원', color: 'secondary', icon: 'account-cancel' }
      ],
      ChargeAmountChartItems: null,
      trnsBtnState: [],
      utilDescription: '',
      userStatusPowerChartOptions: {
        chart: {
          type: 'bar',
          offsetY: -20,
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
          toolbar: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          categories: ['회원', '로밍', '비회원'],
          labels: {
            formatter: val => Math.round(val * 100) / 100,
            style: {
              fontSize: '11px',
              fontWeight: 400,
            },
            maxHeight: 15,
            offsetY: -2,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          }
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '11px',
              fontWeight: 600,
            },
            minWidth: 40,
            offsetX: 5,
            offsetY: 4,
          },
        },
        tooltip: {
          y: {
            formatter: y => `${y} kWh`,
          }
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
          }
        },
        series: [
          {
            name: '충전량',
            color: '#0576b9',
            showInLegend: false,
            data: []
          }
        ],
        noData: {
          text: 'No Data',
          offsetX: 20,
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        grid: {
          show: true,
          xaxis: {
            lines: {
              show: true,
            }
          },
          yaxis: {
            lines: {
              show: false,
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        }
      },
      userStatusPriceChartOptions: {
        chart: {
          type: 'bar',
          offsetY: -20,
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
          toolbar: {
            show: false,
          },
        },
        fill: {
          opacity: 1,
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['회원', '로밍', '비회원'],
          labels: {
            formatter: val => val.toLocaleString('ko-KR'),
            style: {
              fontSize: '11px',
              fontWeight: 400,
            },
            maxHeight: 15,
            offsetY: -2,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            style: {
              fontSize: '11px',
              fontWeight: 600,
            },
            minWidth: 40,
            offsetX: 5,
            offsetY: 4,
          },
        },
        tooltip: {
          y: {
            formatter: y => `${y.toLocaleString('ko-KR')} 원`,
          },
        },
        plotOptions: {
          bar: {
            horizontal: true,
            barHeight: '50%',
          }
        },
        series: [
          {
            name: '충전 금액',
            showInLegend: false,
            color: '#f56e50',
            data: []
          }
        ],
        noData: {
          text: 'No Data',
          offsetX: 20,
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        grid: {
          show: true,
          xaxis: {
            lines: {
              show: true,
            }
          },
          yaxis: {
            lines: {
              show: false,
            }
          },
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
        }
      },
      placeStockChartOptions: {
        chart: {
          offsetX: 0,
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
            },
          },
        },
        stroke: {
          curve: 'smooth',
          colors: ['#0576b9', '#f56e50'],
          width: [2, 2],
        },
        colors: ['#0576b9', '#f56e50'],
        xaxis: {
          type: 'datetime',
          categories: [],
          tickAmount: 1,
          labels: {
            show: true,
            rotate: -0.1,
            rotateAlways: true,
            maxHeight: 30,
            formatter: (val, timestamp) => this.$moment(timestamp).format('HH:mm:ss'),
            hideOverlappingLabels: false,
            offsetX: 15,
            offsetY: 10,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: [/*{
          title: {
            text: 'SoC',
            style: {
              fontFamily: 'NanumSquareRound',
              fontWeight: 600,
              color: '#8AD4EB',
            }
          },
          labels: {
            formatter: val => this.$_utils.comma(val),
          },
          min: 0,
          max: 100,
          tickAmount: 2,
          decimalsInFloat: 0,
        }, */{
          title: {
            text: '전류 (A)',
            style: {
              fontFamily: 'NanumSquareRound',
              fontWeight: 600,
              color: '#01B8AA',
            }
          },
          tickAmount: 2,
          max: max => Math.ceil(Math.max(...this.placeStockChartOptions.series[0].data) + 1),
          decimalsInFloat: 0,
        }, {
          title: {
            text: '전압 (V)',
            style: {
              fontFamily: 'NanumSquareRound',
              fontWeight: 600,
              color: '#FD625E',
            }
          },
          opposite: true,
          tickAmount: 2,
          min: min => Math.floor(Math.min(...this.placeStockChartOptions.series[1].data) - 1),
          max: max => Math.floor(Math.max(...this.placeStockChartOptions.series[1].data) + 1),
          decimalsInFloat: 0,
        }],
        series: [{
          name: '전류',
          data: [],
        }, {
          name: '전압',
          data: []
        }],
        noData: {
          text: 'No Data',
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        legend: {
          show: true,
          position: 'bottom',
          formatter:
            (seriesName, opts) => {
              if (opts.seriesIndex === 0) return`${seriesName}`;
              else if (opts.seriesIndex === 1) return `${seriesName}`;
              else return `${seriesName}`;
            },
          markers: {
            width: 12,
            height: [2, 2],
          },
        },
        tooltip: {
          enabled: true,
          marker: {
            show: false,
          },
          custom: function({series, seriesIndex, dataPointIndex, w}) {
            let title = null;

            title = '<div class="temp-arrow-box">'
                + '<span class="title">' + (w.globals.lastXAxis.categories[dataPointIndex]).substring(11) + '</span><br/>'
                + '<span class="value-a">'+ series[0][dataPointIndex] + ' A</span>'
                + '<span class="title"> , </span>'
                + '<span class="value-v">' + series[1][dataPointIndex] + ' V</span>';

            return title;
          }
          /*y: {
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
              let title = null;

              if (seriesIndex === 0) {
                title = `${series[0][dataPointIndex]}A, ${series[1][dataPointIndex]}V`
              }

              return title;
            },
            title: {
              formatter: null,
            },
          }*/
          /*y: [
            {
              formatter: y => `${this.$_utils.comma(y)} %`,
              title : { formatter: seriesName => `${seriesName}:` },
            },
            {
              formatter: y => `${y} A`,
              title : { formatter: seriesName => `${seriesName}:` },
            },
            {
              formatter: y => `${y} V`,
              title : { formatter: seriesName => `${seriesName}:` },
            },
          ],*/
        },
      },
      weekUseStatusChartOptions: {
        chart: {
          toolbar: {
            show: false,
            tools: {
              download: false,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: true | '<img src="/static/icons/reset.png" width="20">',
            },
          },
          fontFamily: 'NanumSquareRound',
          parentHeightOffset: 0
        },
        colors: ['#47bce8', '#f56e50', '#0576b9'],
        fill: {
          opacity: 1,
        },
        stroke: {
          curve: ['smooth', '', 'smooth'],
          width: [2, 0, 3],
          dashArray: [0, 0, 3],
        },
        markers: {
          size: 1,
          strokeWidth: 0,
          hover: {
            sizeOffset: 4
          }
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: ['월', '화', '수', '목', '금', '토', '일'],
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: [{
          seriesName: '이용자',
          opposite: false,
          tickAmount: 2,
          max: max => max < 5 ? 4 : Math.ceil(max / 10) * 10,
          axisBorder: {
            show: true,
            color: '#47bce8'
          },
          labels: {
            style: {
              colors: ['#47bce8'],
            },
            formatter: val => `${val.toFixed(0)}`,
          },
          title: {
            text: "이용자",
            style: {
              color: '#47bce8',
              fontWeight: 600,
            }
          }
        },
          {
            seriesName: '충전금액',
            opposite: true,
            tickAmount: 4,
            axisBorder: {
              show: true,
              color: '#f56e50',
            },
            labels: {
              style: {
                colors: ['#f56e50'],
              },
              formatter: val => `${val.toLocaleString()}`,
            },
            title: {
              text: "충전금액",
              style: {
                color: '#f56e50',
                fontFamily: 'NanumSquareRound',
                fontWeight: 600,
              }
            },
          },
          {
            seriesName: '충전량',
            opposite: true,
            tickAmount: 4,
            axisBorder: {
              show: true,
              color: '#0576b9'
            },
            labels: {
              style: {
                colors: ['#0576b9'],
              },
              formatter: val => `${val.toFixed(2)}`,
            },
            title: {
              text: "충전량",
              style: {
                color: '#0576b9',
                fontFamily: 'NanumSquareRound',
                fontWeight: 600,
              }
            },
          }
        ],
        legend: {
          position: 'bottom',
          offsetY: 8,
          fontFamily: 'NanumSquareRound',
          markers: {
            width: 12,
            height: [2, 12, 2],
            strokeWidth: 0,
            radius: 2,
          },
        },
        tooltip: {
          enabled: true,
          y: [{
            formatter: y => `${y.toFixed(0)} 명`,
            title : { formatter: seriesName => `${seriesName}:` },
          },{
            formatter: y => `${y.toLocaleString('ko-KR')} 원`,
            title : { formatter: seriesName => `${seriesName}:` },
          },{
            formatter: y => `${Math.round(y * 100) / 100} kWh`,
            title : { formatter: seriesName => `${seriesName}:` },
          }]
        },
        plotOptions: {
          bar: {
            columnWidth: '35%',
            borderRadius: 1,
            borderRadiusApplication: 'end',
          }
        },
        series: [{
          name: '이용자',
          type: 'line',
          data: []
        }, {
          name: '충전금액',
          type: 'bar',
          data: []
        }, {
          name: '충전량',
          type: 'line',
          data: []
        }],
        noData: {
          text: 'No Data',
          offsetY: -15,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
      },
      utilChartOptions: {
        chart: {
          parentHeightOffset: 0,
          fontFamily: 'NanumSquareRound',
          toolbar: { show: false, },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: Array.from({ length: 24 }, (v, i) => i),
          tickPlacement: 'between',
          labels: {
            hideOverlappingLabels: false,
            trim: false,
          },
          axisTicks: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: true,
          tickAmount: 3,
          min: 0,
          max: 75,
          labels: {
            formatter: val => val.toFixed(0)
          }
        },
        series: [{
          name: '이용률',
          data: []
        }],
        noData: {
          text: 'No Data',
          offsetY: -35,
          style: {
            color: '#9599AD',
            fontSize: '15px',
          }
        },
        colors: ['#01B8AA'],
        fill: {
          opacity: 1,
        },
        legend: {
          show: true,
          showForSingleSeries: true,
          position: 'bottom',
          horizontalAlign: 'center',
          formatter:  seriesName => `${seriesName} (%)`,
          markers: {
            radius: 2,
          }
        },
        plotOptions: {
          bar: {
            columnWidth: '50%',
            borderRadius: 1,
            borderRadiusApplication: 'end',
          }
        },
        tooltip: {
          enabled: true,
          x: {
            show: true,
            formatter: x => `${x}시~${x + 1}시`,
          },
          y: {
            formatter: y => typeof y !== "undefined" ? `${y}%` : y,
          },
        },
      },
    }
  },
  created() {
    const vm = this;

    // 충전소 목록
    vm.getStationItems();
  },
  mounted() {
    const vm = this;

    vm.utilDescription =
      `최근 1주일간 해당 충전기의
이용 데이터를 분석한 결과이며
참고로만 사용 바랍니다.`;
  },
  methods: {
    getStationItems() {
      const vm = this;

      vm.stationApi.list()
        .then(res => {
          vm.stationOptions = res;

          if (vm.stationOptions.length > 0) {
            vm.searchForm.station = vm.stationOptions.find(e => e.placeId === '001940');
            vm.searchForm.station = vm.stationOptions[0];
            vm.search();
          }
        }).catch(err => {
          console.log(err);
        });
    },
    search() {
      const vm = this;

      vm.getStatus();
      vm.getStatusItems();

      vm.getFailureStatus();
      vm.getFailureItems();
    },
    searchEvse() {
      const vm = this;
      const searchArgs = [vm.searchForm.station.placeId, vm.searchForm.evse.csId, vm.searchForm.evse.evseId, vm.searchForm.selectedDate]

      vm.getUserUseStatus(searchArgs);
      vm.getChargeAmount(searchArgs);
      vm.getUtilization(searchArgs);
    },
    reset() {
      const vm = this;

      // vm.searchForm.station = null;
      vm.searchForm.station = vm.stationOptions.find(e => e.placeId === '001940');
      vm.searchForm.evse = null;

      vm.status = { total: 0, available: 0, occupied: 0, reserved: 0, faulted: 0 };
      vm.statusItems = null;

      vm.evseItems = null;

      vm.failureStatus = { noneUse: 0, low: 0 };
      vm.failureItems = null;
    },
    getStatus() {
      const vm = this;

      vm.evseApi.requestEvseCount(vm.searchForm.station.placeId)
        .then(res => {
          vm.status = { ...res };
        }).catch(err => {
        console.log(err);
      });
    },
    getStatusItems() {
      const vm = this;

      vm.evseApi.requestEvseStatus(vm.searchForm.station.placeId)
        .then(res => {
          vm.statusItems = res.items;

          // 충전기 목록
          if (vm.statusItems.length > 0) {
            vm.evseOptions = [];
            vm.statusItems.forEach(item => {
              vm.evseOptions.push({ csId: item.csId, evseId: item.evseId, csoEvseNum: item.csoEvseNum });
            });
            vm.searchForm.evse = vm.evseOptions[0];

            vm.searchEvse();
          }
        }).catch(err => {
        console.log(err);
      });
    },
    getStatusTime(data) {
      const _day = data.item.diffDay > 0 ? data.item.diffDay + '일 ' : '';
      const _hour = data.item.diffHour > 0 ? data.item.diffHour + '시간 ' : '';
      const _min = data.item.diffMin > 0 ? data.item.diffMin + '분' : '';
      const dayHourMin = _day + _hour + _min;

      return !this.$_utils.isEmpty(dayHourMin) ? dayHourMin : '-';
    },
    getFailureStatus() {
      const vm = this;

      vm.evseApi.requestNoneUseCount(vm.searchForm.station.placeId, vm.today)
        .then(res => {
          vm.failureStatus.noneUse = res.noneUseCount;
        }).catch(err => {
        console.log(err);
      });

      vm.evseApi.requestLowCount(vm.searchForm.station.placeId, vm.today)
        .then(res => {
          vm.failureStatus.low = res.loweringCnt;
        }).catch(err => {
        console.log(err);
      });
    },
    getFailureItems() {
      const vm = this;

      vm.evseApi.requestFailureCountList(vm.searchForm.station.placeId, vm.today)
        .then(res => {
          vm.failureItems = [...res.items]
        }).catch(err => {
        console.log(err);
      });
    },
    async getUserUseStatus(args) {
      const vm = this;

      try {
        const res = await vm.evseApi.requestUserStat(...args);
        vm.userStatus = Object.assign(vm.userStatus, res.data);

        vm.$refs.userStatusPowerChart.updateSeries([
          { data: [ vm.userStatus.memberEnergy, vm.userStatus.roamingEnergy, vm.userStatus.nonmemberEnergy ] }]);
        vm.$refs.userStatusPriceChart.updateSeries([
          { data: [ vm.userStatus.memberCost, vm.userStatus.roamingCost, vm.userStatus.nonmemberCost ] }]);

        const weekDayArr = vm.userStatus.weekChart.map(obj => {
          const date = `${this.$moment(vm.searchForm.selectedDate).format('YYYY')}-${obj.day}`;
          return this.$moment(date).locale('ko').format('D(ddd)')
        });
        vm.weekUseStatusChartOptions.xaxis.categories = weekDayArr;

        vm.weekUseStatusChartOptions.series[0].data = vm.userStatus.weekChart.map(obj => obj.userCnt);
        vm.weekUseStatusChartOptions.series[1].data = vm.userStatus.weekChart.map(obj => obj.totCost);
        vm.weekUseStatusChartOptions.series[2].data = vm.userStatus.weekChart.map(obj => obj.totEnergy);

        vm.$refs.weekUseStatusChart.updateOptions({
          xaxis: { categories: weekDayArr }
        });
      } catch (err) {
        console.log(err);
      }
    },
    async getChargeAmount(args) {
      const vm = this;

      if (!args[0] || !args[1] || !args[2]) {
        vm.placeStockChartOptions = {
          ...vm.placeStockChartOptions,
          ...{
            series: [{ data: [] }, { data: [] }, { data: [] }]
          }
        };
      } else {
        try {
          const res = await vm.evseApi.requestChargeAmountChartByCsEvseId(...args);
          vm.ChargeAmountChartItems = res;

          vm.trnsBtnState = [ true, ...Array(res.length - 1).fill(false) ];
          vm.updatePlaceStockChart(0);

        } catch (err) {
          vm.ChargeAmountChartItems = null;

          vm.placeStockChartOptions = {
            ...vm.placeStockChartOptions,
            ...{
              xaxis: { categories: [] },
              series: [{ data: [] }, { data: [] }]
            }
          };
        }
      }
    },
    updatePlaceStockChart(clickedIdx) {
      const vm = this;

      const data = [...vm.ChargeAmountChartItems]
      const selectedTrnsId = Object.keys(data[clickedIdx])[0];

      const dataTime = data[clickedIdx][selectedTrnsId].map(ele => ele.meterTime);
      // const dataSOC = data[clickedIdx][selectedTrnsId].map(ele => ele.wattHour);
      const dataSOC = Array(data[clickedIdx][selectedTrnsId].length).fill(0);
      const dataC = data[clickedIdx][selectedTrnsId].map(ele => ele.current);
      const dataV = data[clickedIdx][selectedTrnsId].map(ele => ele.voltage);

      vm.placeStockChartOptions = {
        ...vm.placeStockChartOptions,
        ...{
          xaxis: { categories: dataTime },
          series: [{ data: dataC }, { data: dataV }],
        }
      };
    },
    async getUtilization(args) {
      const vm = this;

      if (!args[1] || !args[2]) {
        vm.utilChartOptions = {
          ...vm.utilChartOptions,
          ...{
            series: [{ data: [] }]
          }
        };
      } else {
        try {
          const res = await vm.evseApi.requestUtilChart(args[1], args[2], args[3]);

          if (res.items.length !== 0) {
            vm.utilChartOptions.xaxis.categories = res.items.map(item => item.utzHour);
            vm.$refs.utilChart.updateSeries([{ data: res.items.map(item => item.utz) }]);
          } else {
            vm.utilChartOptions = {
              ...vm.utilChartOptions,
              ...{
                series: [{ data: [] }]
              }
            };
          }
        } catch (err) {
          console.log(err);
        }
      }
    },
    changeTransactionId(clickedIdx) {
      const vm = this;

      vm.trnsBtnState = vm.trnsBtnState.map((ele, i) => i === clickedIdx);
      vm.updatePlaceStockChart(clickedIdx);
    },
    beforeDate() {
      const vm = this;
      vm.searchForm.selectedDate = vm.$moment(vm.searchForm.selectedDate).subtract(1, 'day').format('YYYY-MM-DD');
      vm.searchEvse();
    },
    nextDate() {
      const vm = this;
      vm.searchForm.selectedDate = vm.$moment(vm.searchForm.selectedDate).add(1, 'day').format('YYYY-MM-DD');
      vm.searchEvse();
    },
    disabledAfterDay(date) {
      const today = new Date();
      return date > today
    },
    setCompare(type, val) {
      if (type === 'text') {
        if (val > 0) return 'text-danger'
        else if (val < 0) return 'text-primary'
        else return 'text-muted'
      } else if (type === 'icon') {
        if (val > 0) return 'bxs-upvote'
        else if (val < 0) return 'bxs-downvote'
        else return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .temp-arrow-box {
    font-size: 14px;
    padding: 5px 10px;
    background: #000000;

    .title {
      font-weight: bold;
      color: #e7e7e7;
    }

    .value-a {
      color: #41b4f8
    }

    .value-v {
      color: #fc9c88
    }
  }

  .tooltip-inner {
    text-align: left;
    max-width: 100%;
  }
}
</style>